"use client";
// Re-export components directly to enable tree-shaking
// Only components that are actually imported by consuming files will be bundled

export { default as Carousel } from "react-bootstrap/Carousel";
export { default as CarouselItem } from "react-bootstrap/CarouselItem";
export { default as Col } from "react-bootstrap/Col";
export { default as Row } from "react-bootstrap/Row";
export { default as Button } from "react-bootstrap/Button";
export { default as ButtonGroup } from "react-bootstrap/ButtonGroup";
export { default as DropdownButton } from "react-bootstrap/DropdownButton";
export { default as Dropdown } from "react-bootstrap/Dropdown";
export { default as DropdownItem } from "react-bootstrap/DropdownItem";
export { default as NavLink } from "react-bootstrap/NavLink";
export { default as NavDropdown } from "react-bootstrap/NavDropdown";
export { default as Modal } from "react-bootstrap/Modal";
export { default as Spinner } from "react-bootstrap/Spinner";
export { default as Collapse } from "react-bootstrap/Collapse";
export { default as Accordion } from "react-bootstrap/Accordion";
export { default as Toast } from "react-bootstrap/Toast";
export { default as ToastContainer } from "react-bootstrap/ToastContainer";
export { default as Nav } from "react-bootstrap/Nav";
export { default as Navbar } from "react-bootstrap/Navbar";
export { default as ProgressBar } from "react-bootstrap/ProgressBar";
export { default as OverlayTrigger } from "react-bootstrap/OverlayTrigger";
export { default as Overlay } from "react-bootstrap/Overlay";

export { default as Form } from "react-bootstrap/Form";
